import { PREFERRED_LOCALES } from 'es/app/business-logic/domain-models/Locale';
import { DropDownControl } from 'es/app/components/forms/components';
import { useUpdateFieldValue } from 'es/app/components/forms/FormikForm';
import { SSOUserTemplateFormFields } from 'es/app/views/system/sso-user-templates/SsoUserTemplates.types';

type LocalSelectorProps = {
    id: string;
    value: string;
};

export function LocaleSelector({ id, value }: LocalSelectorProps) {
    const updateField = useUpdateFieldValue<SSOUserTemplateFormFields>();
    return (
        <DropDownControl
            data={PREFERRED_LOCALES.map(item => ({ ...item, key: item.id }))}
            onChange={fieldValue => updateField({ fieldName: 'locale', fieldValue })}
            value={value}
            valueField="id"
            textField="name"
            inputId={id}
        />
    );
}
